var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-inline-flex mb-4" }, [
      _vm.animationFields && _vm.animationFields.length
        ? _c("div", { staticClass: "form-check mr-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectAll,
                  expression: "selectAll"
                }
              ],
              staticClass: "check form-check-input select-all mt-0",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.selectAll)
                  ? _vm._i(_vm.selectAll, null) > -1
                  : _vm.selectAll
              },
              on: {
                change: function($event) {
                  var $$a = _vm.selectAll,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectAll = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectAll = $$c
                  }
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "mr-3 mb-0" }, [_vm._v("Animations ")]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "span",
          {
            staticClass: "cursor-pointer",
            on: {
              click: function($event) {
                return _vm.addNewAnimation()
              }
            }
          },
          [
            _c("img", {
              staticClass: "heading-icon",
              attrs: { src: require("@/assets/addplus_icon.svg"), width: "20" }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isSelected
          ? _c(
              "span",
              {
                staticClass: "cursor-pointer ml-3",
                on: {
                  click: function($event) {
                    return _vm.deleteAllAnimations()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-trash" })]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      _vm._l(_vm.animationFields, function(item, index) {
        return _c("div", { key: index }, [
          _c(
            "div",
            { staticClass: "fields-wrapper is-divider is-multi-node mb-3" },
            [
              _c("div", { staticClass: "form-check select-single" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.animation.selectSingle,
                      expression: "item.animation.selectSingle"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(item.animation.selectSingle)
                      ? _vm._i(item.animation.selectSingle, null) > -1
                      : item.animation.selectSingle
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = item.animation.selectSingle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                item.animation,
                                "selectSingle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                item.animation,
                                "selectSingle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(item.animation, "selectSingle", $$c)
                        }
                      },
                      _vm.checkSingleSelect
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-buttons" }, [
                _c(
                  "span",
                  {
                    staticClass: "action-item ",
                    on: {
                      click: function($event) {
                        return _vm.copyAnimation(index, item)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-copy" })]
                ),
                _vm._v(" "),
                item.animation.selectSingle
                  ? _c(
                      "span",
                      {
                        staticClass: "action-item",
                        on: {
                          click: function($event) {
                            return _vm.deleteAnimation(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-5 col-form-label",
                            attrs: { for: "animation_selector" }
                          },
                          [
                            _vm._v(
                              "\n                  Animation Selector\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.animation.animationId,
                                  expression: "item.animation.animationId"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: { id: "animation_selector" },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      item.animation,
                                      "animationId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.changeSelectedAnimation(
                                      index,
                                      item
                                    )
                                  }
                                ]
                              }
                            },
                            _vm._l(_vm.assetAnimations, function(
                              animation,
                              index
                            ) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  staticClass: "custom-select",
                                  domProps: { value: index }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(animation.name) +
                                      "\n                    "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n                  Start Time (sec)\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.animation.startTime,
                                expression: "item.animation.startTime"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              id: index,
                              min:
                                index !== 0
                                  ? parseInt(
                                      _vm.animationFields[index - 1].animation
                                        .startTime
                                    )
                                  : 0
                            },
                            domProps: { value: item.animation.startTime },
                            on: {
                              change: _vm.checkStartTime,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item.animation,
                                  "startTime",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n                  End Time (sec)\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.animation.endTime,
                                expression: "item.animation.endTime"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number", id: index },
                            domProps: { value: item.animation.endTime },
                            on: {
                              change: _vm.checkEndTime,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item.animation,
                                  "endTime",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n                  Animation Duration (sec)\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", readonly: "" },
                            domProps: {
                              value:
                                (
                                  (item.animation.endTime -
                                    item.animation.startTime) *
                                  item.animation.loopCount
                                ).toFixed(2) || 0
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n                  Number of Loops\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.animation.loopCount,
                                expression: "item.animation.loopCount"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number", min: "1" },
                            domProps: { value: item.animation.loopCount },
                            on: {
                              change: function($event) {
                                return _vm.setDuration(index)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item.animation,
                                  "loopCount",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-5 col-form-label",
                            attrs: { for: "rig" }
                          },
                          [_vm._v("\n                  Rig\n                ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.animation.rig,
                                expression: "item.animation.rig"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "animname",
                              readonly: ""
                            },
                            domProps: { value: item.animation.rig },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item.animation,
                                  "rig",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-5 col-form-label",
                            attrs: { for: "inverse_kinematics" }
                          },
                          [
                            _vm._v(
                              "\n                  Inverse Kinematics\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.animation.inverseKinematics,
                                  expression: "item.animation.inverseKinematics"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: { id: "inverse_kinematics" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    item.animation,
                                    "inverseKinematics",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", [_vm._v("Link 1")]),
                              _vm._v(" "),
                              _c("option", [_vm._v("Link 2")]),
                              _vm._v(" "),
                              _c("option", [_vm._v("Link 3")])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n                  Trim\n                ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.animation.trim,
                                expression: "item.animation.trim"
                              }
                            ],
                            attrs: { type: "range", min: "1", max: "100" },
                            domProps: { value: item.animation.trim },
                            on: {
                              __r: function($event) {
                                return _vm.$set(
                                  item.animation,
                                  "trim",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(_vm._s(item.animation.trim))
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 align-items-center" }, [
                    _c("div", { staticClass: "row form-group mb-4" }, [
                      _c("label", { staticClass: "col-sm-5 col-form-label" }, [
                        _vm._v(
                          "\n                  Test Animation\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-7" }, [
                        _vm.isPreviewPaused || !_vm.isPreviewStarted
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-success",
                                attrs: { id: "select_audio_duration_s" },
                                on: {
                                  click: function($event) {
                                    return _vm.startPreview(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-play" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isPreviewStarted && !_vm.isPreviewPaused
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-warning",
                                attrs: { id: "select_audio_duration_pause" },
                                on: {
                                  click: function($event) {
                                    return _vm.pausePreview(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-pause" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-danger",
                            attrs: { id: "select_audio_duration_stop" },
                            on: {
                              click: function($event) {
                                return _vm.stopPreview(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-stop" })]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-5 col-form-label",
                            attrs: { for: "no_of_joints" }
                          },
                          [
                            _vm._v(
                              "\n                  Joints Count\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.animation.jointsCount,
                                expression: "item.animation.jointsCount"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "no_of_joints",
                              readonly: ""
                            },
                            domProps: { value: item.animation.jointsCount },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item.animation,
                                  "jointsCount",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n                  Destination Postion\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.animation.destination.position[0],
                                    expression:
                                      "item.animation.destination.position[0]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "destination_position_x"
                                },
                                domProps: {
                                  value: item.animation.destination.position[0]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item.animation.destination.position,
                                      0,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.animation.destination.position[1],
                                    expression:
                                      "item.animation.destination.position[1]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "destination_position_y"
                                },
                                domProps: {
                                  value: item.animation.destination.position[1]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item.animation.destination.position,
                                      1,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.animation.destination.position[2],
                                    expression:
                                      "item.animation.destination.position[2]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "destination_position_z"
                                },
                                domProps: {
                                  value: item.animation.destination.position[2]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item.animation.destination.position,
                                      2,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n                  Destination Rotation\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.animation.destination.rotation[0],
                                    expression:
                                      "item.animation.destination.rotation[0]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "destination_position_x"
                                },
                                domProps: {
                                  value: item.animation.destination.rotation[0]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item.animation.destination.rotation,
                                      0,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.animation.destination.rotation[1],
                                    expression:
                                      "item.animation.destination.rotation[1]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "destination_position_y"
                                },
                                domProps: {
                                  value: item.animation.destination.rotation[1]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item.animation.destination.rotation,
                                      1,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      item.animation.destination.rotation[2],
                                    expression:
                                      "item.animation.destination.rotation[2]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "destination_position_z"
                                },
                                domProps: {
                                  value: item.animation.destination.rotation[2]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item.animation.destination.rotation,
                                      2,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.hasNext(index)
            ? _c("div", { staticClass: "fields-wrapper is-multi-node" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c("h4", [_vm._v("Stitch")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-5 col-form-label",
                            attrs: { for: "stitch" }
                          },
                          [
                            _vm._v(
                              "\n              Stitch Selector\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.animation.stitch,
                                  expression: "item.animation.stitch"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: { id: "stitch" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    item.animation,
                                    "stitch",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "Reaction" } }, [
                                _vm._v("Reaction")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "Burpee" } }, [
                                _vm._v("Burpee")
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c("h4", [_vm._v("Blend")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-5 col-form-label",
                            attrs: { for: "blend" }
                          },
                          [
                            _vm._v(
                              "\n              Blend Selector\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.animation.blend,
                                  expression: "item.animation.blend"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: { id: "blend" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    item.animation,
                                    "blend",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "Reaction" } }, [
                                _vm._v("Reaction")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "Burpee" } }, [
                                _vm._v("Burpee")
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35c68836", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c68836","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/character/animations.vue
// module id = null
// module chunks = 